import React, { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Name is required';
    if (!form.email.trim()) e.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Enter a valid email';
    if (!form.subject.trim()) e.subject = 'Subject is required';
    if (!form.message.trim()) e.message = 'Message is required';
    else if (form.message.trim().length < 20) e.message = 'Message must be at least 20 characters';
    return e;
  };

  const handleChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    if (errors[e.target.name]) setErrors(er => ({ ...er, [e.target.name]: '' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const e2 = validate();
    if (Object.keys(e2).length) { setErrors(e2); return; }
    setSubmitted(true);
  };

  if (submitted) return (
    <main className="contact-page">
      <div className="container">
        <div className="success-box">
          <div className="success-icon">✓</div>
          <h2>Message Sent!</h2>
          <p>Thanks for reaching out, <strong>{form.name}</strong>. We'll get back to you at <strong>{form.email}</strong> within 1–2 business days.</p>
          <button className="submit-btn" onClick={() => { setSubmitted(false); setForm({ name:'',email:'',subject:'',message:'' }); }}>Send Another Message</button>
        </div>
      </div>
    </main>
  );

  return (
    <main className="contact-page">
      <div className="page-hero">
        <div className="container">
          <div className="hero-badge">Contact</div>
          <h1>Get in <span className="glow-text">Touch</span></h1>
          <p>Have a bug report, feature request, or just a question? We'd love to hear from you.</p>
        </div>
      </div>
      <div className="container">
        <div className="contact-grid">
          <div className="contact-form-wrap">
            <h2>Send Us a Message</h2>
            <form className="contact-form" onSubmit={handleSubmit} noValidate>
              <div className="form-row">
                <div className={`field ${errors.name ? 'error' : ''}`}>
                  <label>Full Name</label>
                  <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="John Doe" />
                  {errors.name && <span className="field-error">{errors.name}</span>}
                </div>
                <div className={`field ${errors.email ? 'error' : ''}`}>
                  <label>Email Address</label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="john@example.com" />
                  {errors.email && <span className="field-error">{errors.email}</span>}
                </div>
              </div>
              <div className={`field ${errors.subject ? 'error' : ''}`}>
                <label>Subject</label>
                <select name="subject" value={form.subject} onChange={handleChange}>
                  <option value="">Select a topic…</option>
                  <option value="bug">Bug Report</option>
                  <option value="feature">Feature Request</option>
                  <option value="question">General Question</option>
                  <option value="other">Other</option>
                </select>
                {errors.subject && <span className="field-error">{errors.subject}</span>}
              </div>
              <div className={`field ${errors.message ? 'error' : ''}`}>
                <label>Message</label>
                <textarea name="message" value={form.message} onChange={handleChange} rows={6} placeholder="Describe your issue or question in detail…" />
                <div className="char-count">{form.message.length} characters</div>
                {errors.message && <span className="field-error">{errors.message}</span>}
              </div>
              <button type="submit" className="submit-btn">Send Message →</button>
            </form>
          </div>
          <aside className="contact-sidebar">
            <div className="info-card">
              <h4>📬 Response Time</h4>
              <p>We typically respond within 1–2 business days. For urgent issues, please mark your subject as "Urgent".</p>
            </div>
            <div className="info-card">
              <h4>🐛 Reporting Bugs</h4>
              <p>When reporting a bug, please include your browser name and version, operating system, keyboard model (if known), and a description of what you expected vs. what happened.</p>
            </div>
            <div className="info-card">
              <h4>💡 Feature Requests</h4>
              <p>We love hearing ideas from our users. All feature requests are reviewed and considered for future updates. Popular requests are prioritized.</p>
            </div>
            <div className="info-card accent-info">
              <h4>🔒 Privacy Note</h4>
              <p>Your contact information is used solely to respond to your inquiry. We never share your data with third parties or use it for marketing purposes.</p>
            </div>
          </aside>
        </div>
      </div>
    </main>
  );
}
